var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "c-sidesheet",
    {
      attrs: { id: "type-modal", active: _vm.displayModal },
      on: { close: _vm.close },
    },
    [
      _c("m-confirm", { ref: "confirm", attrs: { mode: "danger" } }),
      _c("div", { staticClass: "modal-frame" }, [
        _c(
          "div",
          { staticClass: "modal-wrapper" },
          [
            _c(
              "shadow-scroll-container",
              {
                ref: "track",
                staticClass: "modal-track",
                attrs: { "with-top-scroller": true },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "violation-type",
                    class: {
                      "edit-mode": _vm.violation,
                    },
                  },
                  [
                    _c("div", { staticClass: "violation-type__wrapper" }, [
                      _c("div", { staticClass: "modal-frame__header" }, [
                        _c("h2", { staticClass: "modal-frame__title" }, [
                          _vm._v(_vm._s(_vm.modalTitle)),
                        ]),
                        _c(
                          "div",
                          { staticClass: "modal-frame__actions" },
                          [
                            _vm.violation && !_vm.violation.is_system
                              ? _c("c-button", {
                                  staticClass: "violation-type__remove",
                                  attrs: {
                                    size: "small",
                                    label: "Удалить",
                                    icon: { icon: "trash", color: "secondary" },
                                  },
                                  on: { click: _vm.remove },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      !_vm.violation ||
                      (_vm.violation && !_vm.violation.is_system)
                        ? _c(
                            "div",
                            { staticClass: "form-group violation-type__type" },
                            [
                              _c("c-input", {
                                class: {
                                  "is-invalid":
                                    _vm.isSubmitted && _vm.nameError,
                                },
                                attrs: {
                                  "max-length": 255,
                                  "floating-label": "Наименование",
                                  clearable: true,
                                  "required-mark": true,
                                  required: _vm.isSubmitted && _vm.nameError,
                                  "required-condition":
                                    _vm.isSubmitted && _vm.nameError,
                                },
                                model: {
                                  value: _vm.form.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "name", $$v)
                                  },
                                  expression: "form.name",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.violation ||
                      (_vm.violation && !_vm.violation.is_system)
                        ? _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col col-12 col-md-5 col-xl-3" },
                              [
                                _c("c-input", {
                                  attrs: {
                                    type: "select",
                                    items: _vm.collections.modules,
                                    clearable: true,
                                    "floating-label":
                                      "Основная единица измерения",
                                  },
                                  model: {
                                    value: _vm.form.module,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "module", $$v)
                                    },
                                    expression: "form.module",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col col-12 col-md-5 col-xl-3" },
                              [
                                _c("c-switcher", {
                                  staticClass: "can-change-in-post-settings",
                                  attrs: {
                                    type: "checkbox",
                                    label:
                                      "Можно менять в настройках должности",
                                  },
                                  model: {
                                    value: _vm.form.can_change_in_post_settings,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "can_change_in_post_settings",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.can_change_in_post_settings",
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      !_vm.violation ||
                      (_vm.violation && !_vm.violation.is_system)
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              staticStyle: { "margin-bottom": "10px" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col col-12 col-md-10 col-xl-6",
                                },
                                [
                                  _c("c-switcher", {
                                    staticClass: "quantitative-indicator",
                                    attrs: {
                                      type: "checkbox",
                                      label:
                                        "Количественный показатель для норматива",
                                      "label-full-name":
                                        "Количественный показатель для норматива",
                                    },
                                    model: {
                                      value: _vm.form.quantitative_indicator,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "quantitative_indicator",
                                          $$v
                                        )
                                      },
                                      expression: "form.quantitative_indicator",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.violation && _vm.violation.is_system
                        ? _c("div", { staticClass: "system" }, [
                            _c("div", { staticClass: "system__item" }, [
                              _c("div", { staticClass: "system__item-name" }, [
                                _vm._v("Наименование:"),
                              ]),
                              _c("div", { staticClass: "system__item-value" }, [
                                _vm._v(_vm._s(_vm.violation.name)),
                              ]),
                            ]),
                            _c("div", { staticClass: "system__item" }, [
                              _c("div", { staticClass: "system__item-name" }, [
                                _vm._v("Основная единица измерения:"),
                              ]),
                              _c("div", { staticClass: "system__item-value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.form.can_change_in_post_settings
                                      ? _vm.form.module.label +
                                          ", можно менять в настройках должности"
                                      : _vm.form.module.label
                                  )
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "system__item" }, [
                              _c("div", { staticClass: "system__item-name" }, [
                                _vm._v("Количественный показатель:"),
                              ]),
                              _c("div", { staticClass: "system__item-value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.violation.quantitative_indicator
                                      ? "Да"
                                      : "Нет"
                                  )
                                ),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "form-group violation-type__description",
                        },
                        [
                          _c("c-textarea", {
                            staticClass: "description",
                            attrs: {
                              "floating-label": "Описание",
                              clearable: true,
                            },
                            model: {
                              value: _vm.form.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "description", $$v)
                              },
                              expression: "form.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "violation-type__top" },
                      [
                        _c("top-button", {
                          staticClass: "top-button",
                          attrs: { root: `#violation-type-scroll-${_vm._uid}` },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "violation-type__actions" },
                      [
                        _c("c-button", {
                          staticClass: "violation-type__reset",
                          attrs: { size: "large", label: "Отменить" },
                          on: { click: _vm.close },
                        }),
                        _c("c-button", {
                          staticClass: "violation-type__save",
                          attrs: {
                            label: "Сохранить",
                            color: "primary",
                            size: "large",
                          },
                          on: { click: _vm.submit },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "modal-actions" },
          [
            _c("c-button", {
              attrs: { size: "large", label: "Отменить" },
              on: { click: _vm.close },
            }),
            _c("c-button", {
              attrs: { label: "Сохранить", color: "primary", size: "large" },
              on: { click: _vm.submit },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }